module.exports = __webpack_public_path__ + "static/media/2016118122096-46.726f0b31.jpg";